// extracted by mini-css-extract-plugin
export default {"select":"Dropdown_select__SthRx","label":"Dropdown_label__bSwJS"};